export const ESTADO_ACTIVO_DISPLAY = 'Activo';

export const ESTADO_NO_ACTIVO_DISPLAY = 'No activo';
